import {
  getMemberErrorMessage,
  inviteMember,
} from "@risalabs_frontend_org/auth-wrapper";
import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { ChangeEvent, useState } from "react";
import { Modal, TextInput } from "risa-oasis-ui_v2";
import { MemberManagementError } from "../../../../shared/api/services/memberManagementTypes";
import { RbacRoleId } from "../../../../shared/enums/rbacRoles";
import CustomRadioButton from "../../customRadioButton/customRadioButton";
import { ToastMessages } from "../../toasts/toastMessages";

interface InvitationModalProps {
  facilityId: string;
  onModalClose?: (boolean) => void;
}
const HealthCareInvitationModal = (props: InvitationModalProps) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState("0");

  const isAdminOptions = [
    { label: "Yes", value: "1" },
    { label: "No", value: "0" },
  ];

  const handleInputChange = (data) => {
    if (data.name === "name") {
      setName(data.value);
    } else {
      setEmail(data.value);
    }
  };

  const addInvitationToFirebase = async () => {
    setLoading(true);
    const roleId =
      isAdmin === "1" ? RbacRoleId.ADMIN_MED_ONC : RbacRoleId.STANDARD_MED_ONC;

    try {
      await inviteMember(props.facilityId, {
        name: name,
        email: email,
        roleId: roleId,
      });
      toast.success(ToastMessages.INVITATION_SUCCESS);
      props?.onModalClose && props?.onModalClose(false);
    } catch (error) {
      const apiError = error as MemberManagementError;
      const errorMessage = apiError.message || getMemberErrorMessage(apiError);
      console.error("Failed to invite member:", errorMessage);
      toast.error(ToastMessages.INVITATION_FAILURE);
    } finally {
      setName("");
      setEmail("");
      setLoading(false);
    }
  };

  const onModalClose = () => {
    setName("");
    setEmail("");
    props?.onModalClose && props?.onModalClose(false);
  };
  return (
    <Modal
      dialogId={"invitation-modal"}
      onSave={addInvitationToFirebase}
      title={"Invite Member"}
      saveButtonText={loading ? "Inviting..." : "Invite"}
      cancelText={"Cancel"}
      disableSave={name.trim() === "" || email.trim() === "" || loading}
      onClose={onModalClose}
    >
      <div className="invitation-form-container">
        <form>
          <TextInput
            id={"name"}
            label={"Name"}
            required
            onChange={handleInputChange}
            error={name.trim() === "" ? "Please provide a name" : ""}
            resetField={name === ""}
          />
          <TextInput
            id={"email"}
            label={"Email"}
            required
            onChange={handleInputChange}
            error={email.trim() === "" ? "Please provide an email" : ""}
            resetField={email === ""}
          />
          <div className="radio-button-container">
            <div className="radio-button-container--heading">
              Should the user be an Admin?
            </div>
            <div className="radio-button-container--buttons">
              {isAdminOptions.map((option) => (
                <CustomRadioButton
                  key={option.value}
                  name={"isAdmin"}
                  value={option.value}
                  checked={isAdmin === option.value}
                  label={option.label}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    setIsAdmin(e.target.value)
                  }
                />
              ))}
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default HealthCareInvitationModal;
